exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".white-box[data-v-09e88f81]{background-color:#fff;padding:20px;border-radius:10px;box-shadow:0 0 10px #d3d3d3;width:500px;margin:50px auto;text-align:center}.form-field[data-v-09e88f81]{margin-bottom:1em}label[data-v-09e88f81]{display:inline-block;width:6em;text-align:right;margin-right:1em}input[type=text][data-v-09e88f81]{width:20em}button[type=submit][data-v-09e88f81]{margin-left:7em}input[readonly][data-v-09e88f81]{background-color:#d3d3d3;color:grey;cursor:default}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./src/components/userprofile/UserProfile.vue?vue&type=style&index=0&id=09e88f81&prod&scoped=true&lang=css&
// module id = 1563
// module chunks = 0